import React from "react";
import Markdown from "react-markdown";
import * as styles from "./styles.module.css";
import PropTypes from "prop-types";
import { COMMON_HEADER } from "../consent/consents";
import { Accordion } from "@ebscois/react-component-library";

const markDownConfig = {
  p: ({ node, ...props }) => <p className={styles.rawPara} {...props} />,
  ul: ({ node, ...props }) => <ul className={styles.listStyle} {...props} />,
  h1: ({ node, ...props }) => (
    <article className={styles.title}>
      <h1 {...props} />
    </article>
  ),
  h2: ({ node, ...props }) => (
    <article className={styles.rawHeader}>
      <h2 {...props} />
    </article>
  ),
  h3: ({ node, ...props }) => (
    <article className={styles.rawHeader}>
      <h3 {...props} />
    </article>
  ),
  a: ({ node, ...props }) => (
    <a {...props} target="_blank" rel="noopener noreferrer" />
  ),
};

const DEFAULT_ACCORDION_MESSAGE = "Learn more about what we collect and why";
const SHOW_LESS_MESSAGE = "Show less";

const ConsentMessage = ({ prompt }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const handleClick = (e) => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <Markdown children={COMMON_HEADER} components={markDownConfig} />
      <div className={styles.accordionWrapper}>
        <Accordion
          toggleText={isOpen ? SHOW_LESS_MESSAGE : DEFAULT_ACCORDION_MESSAGE}
          variant="secondary"
          isOpen={isOpen}
          onClick={handleClick}
        >
          <Markdown
            children={prompt}
            components={{
              ...markDownConfig,
              h1: ({ node, ...props }) => (
                <article className={styles.accordionTitle}>
                  <h2 {...props} />
                </article>
              ),
            }}
          />
        </Accordion>
      </div>
    </>
  );
};

ConsentMessage.propTypes = {
  prompt: PropTypes.string.isRequired,
};

export default ConsentMessage;
